import { useEffect, useState } from "react";
import "./App.css";
import Admin from "./admin/Admin";
import Home from "./home/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    // const res = await axios.get("http://localhost:4000/data");
    const res = await axios.get("/data");
    setUser(res.data[0]);
  }
  return (
    user && (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home user={user} />}></Route>
            <Route path="/admin" element={<Admin user={user} />}></Route>
          </Routes>
        </BrowserRouter>
        <img
          src={user.work_experience[0].bg_img}
          style={{ display: "none" }}
        ></img>
        <img src={user.education[0].bg_img} style={{ display: "none" }}></img>
        <img src={user.skill_bg_img} style={{ display: "none" }}></img>
      </div>
    )
  );
}

export default App;
